import { NgModule, LOCALE_ID, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import locale from '@angular/common/locales/en';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgxWebstorageModule } from 'ngx-webstorage';
import dayjs from 'dayjs/esm';
import { NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';




import { ApplicationConfigService } from 'app/core/config/application-config.service';
import './config/dayjs';
import { SharedModule } from 'app/shared/shared.module';
import { TranslationModule } from 'app/shared/language/translation.module';
import { AppRoutingModule } from './app-routing.module';
import { HomeModule } from './home/home.module';
// jhipster-needle-angular-add-module-import JHipster will add new module here
import { NgbDateDayjsAdapter } from './config/datepicker-adapter';
import { fontAwesomeIcons } from './config/font-awesome-icons';
import { httpInterceptorProviders } from 'app/core/interceptor/index';
import { MainComponent } from './layouts/main/main.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { PageRibbonComponent } from './layouts/profiles/page-ribbon.component';
import { ActiveMenuDirective } from './layouts/navbar/active-menu.directive';
import { ErrorComponent } from './layouts/error/error.component';
// Dependency
import { MatMenuModule } from '@angular/material/menu';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { NewstickerComponent } from './newsticker/newsticker.component';

import { WhatsNewComponent } from './whats-new/whats-new.component';
import { HomeContentComponent } from './home-content/home-content.component';
import { CustomComponent } from './custom/custom.component';
import { GSTComponent } from './gst/gst.component';
import { MatDividerModule } from '@angular/material/divider';
import { ServiceTaxComponent } from './service-tax/service-tax.component';
import { ViewAllStickerComponent } from './view-all-sticker/view-all-sticker.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { TaxpayerComponent } from './taxpayer/taxpayer.component';
import { DepartmentalOfficeComponent } from './departmental-office/departmental-office.component';
import { InternationalTravellersComponent } from './international-travellers/international-travellers.component';
import { TendersAuctionsComponent } from './tenders-auctions/tenders-auctions.component';
import { NewsMediaComponent } from './news-media/news-media.component';

import { ChairmanDeskComponent } from './chairman-desk/chairman-desk.component';
import { GlobalErrorHandler } from './core/interceptor/global-error-handler';
import { InnerComponentComponent } from './chairman-desk/inner-component/inner-component.component';
import { InnerComponentImageComponent } from './chairman-desk/inner-component-image/inner-component-image.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatPaginatorModule } from '@angular/material/paginator';
import { LoaderComponent } from './layouts/loader/loader.component';
import { PopUpNotificationComponent } from './pop-up-notification/pop-up-notification.component';
// import { NewsletterComponent } from './chairman-desk/newsletter/newsletter.component';
import { NewsMediaTableviewComponent } from './news-media/news-media-tableview/news-media-tableview.component';
import { MediaComponent } from './layouts/media/media.component';
import { NewsletterComponent } from './chairman-desk/newsletter/newsletter.component';
import { WhoWeAreComponent } from './about/who-we-are/who-we-are.component';
import { CbicContentMstModule } from './entities/cbic-content-mst/cbic-content-mst.module';
import { SearchComponent } from './search/search.component';

import { ExciseComponent } from './excise/excise.component';
import { DigitalLibraryComponent } from './digital-library/digital-library.component';
import { ScamComponent } from './scam-alert/scam-alert.component';


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HomeModule,
    MatMenuModule,
    MatTabsModule,
    CdkAccordionModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
    // jhipster-needle-angular-add-module JHipster will add new module here
    AppRoutingModule, NgxPaginationModule, MatPaginatorModule,
    // Set this to true to enable service worker (PWA)
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
    HttpClientModule,
    NgxWebstorageModule.forRoot({ prefix: 'cbic', separator: '-', caseSensitive: true }),
    TranslationModule,
    CbicContentMstModule,
    


  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    MatFormFieldModule,

  ],
  providers: [
    Title,
    { provide: LOCALE_ID, useValue: 'en' },
    { provide: NgbDateAdapter, useClass: NgbDateDayjsAdapter },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    httpInterceptorProviders,
  ],
  declarations: [MainComponent, NavbarComponent, ErrorComponent, PageRibbonComponent,
    ActiveMenuDirective, FooterComponent, NewstickerComponent, NavbarComponent, WhatsNewComponent,
    HomeContentComponent, CustomComponent, GSTComponent, ServiceTaxComponent, ViewAllStickerComponent, TaxpayerComponent, DepartmentalOfficeComponent, InternationalTravellersComponent,
    TendersAuctionsComponent, NewsMediaComponent, ChairmanDeskComponent,
    InnerComponentComponent, InnerComponentImageComponent, LoaderComponent, PopUpNotificationComponent, // NewsletterComponent,
    NewsMediaTableviewComponent, MediaComponent, NewsletterComponent, WhoWeAreComponent, SearchComponent,ExciseComponent,DigitalLibraryComponent,ScamComponent
  ],
  bootstrap: [MainComponent],
})
export class AppModule {
  constructor(applicationConfigService: ApplicationConfigService, iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig) {
    applicationConfigService.setEndpointPrefix(SERVER_API_URL);
    registerLocaleData(locale);
    iconLibrary.addIcons(...fontAwesomeIcons);
    dpConfig.minDate = { year: dayjs().subtract(100, 'year').year(), month: 1, day: 1 };
  }
}   
